<template>
  <div class="table-page">
    <el-card
      class="box-card"
      :body-style="{ padding: bodyPadding, border: bodyBorder }"
      :shadow="shadowType"
    >
      <slot name="headerInput" />
      <div class="flex-box fx-al-c fx-ju-sb">
        <slot name="header" />
      </div>
      <!-- 表格 -->
      <div id="tablearea" class="table-area">
        <el-table
          v-if="isTable"
          ref="table"
          :empty-text="emptyText"
          border
          :height="height"
          :size="tableSize"
          :data="tableData"
          :stripe="stripe"
          :cell-style="cellStyle"
          highlight-current-row
          :show-summary="showSummary"
          :row-key="getRowkey"
          :default-expand-all="expandAll"
          :expand-row-keys="expandRowKeys"
          @filter-change="filterChange"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          @row-dblclick="rowDbclick"
          @cell-click="cellClick"
          @row-click="rowClick"
          @selection-change="selectionChange"
        >
          <!--  :summary-method="summaryMethod" -->
          <slot name="tableColumn" />
        </el-table>
      </div>
      <!-- 分页 -->
      <div :style="fenyeStyle" class="pagination-container">
        <div>
          &nbsp;&nbsp;&nbsp;
          <slot name="footerSelect" />
        </div>
        <el-pagination
          :small="smallPag"
          :current-page.sync="table.pageNum"
          :page-size="table.pageSize"
          :total="table.count"
          :page-sizes="pageSizes"
          :layout="layout"
          background
          class="pagination"
          @current-change="changePage"
          @size-change="changeSize"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "TablePage",
  props: {
    // 传入的表格数据
    table: {
      type: Object,
      default: () => ({
        data: [], // 数据
        page: 1, // 当前页数
        limit: 10, // 一页显示数量
        count: 0, // 总数量
      }),
    },
    resetScroll: {
      type: Boolean,
      default: true,
    },
    cellStyle: {
      type: Function,
      default: (param) => {},
    },
    // 斑马纹表格
    stripe: {
      type: Boolean,
      default: false,
    },
    // 竖直方向边框
    border: {
      type: Boolean,
      default: false,
    },
    // 总计行
    showSummary: {
      type: Boolean,
      default: false,
    },
    // 总计方法
    summaryMethod: {
      type: Function,
      default: (param) => {},
    },
    // 全部展开
    expandAll: {
      type: Boolean,
      default: false,
    },
    // 默认展开的行的id
    expandRowKeys: {
      type: Array,
      default: () => [],
    },
    // 分页style
    fenyeStyle: {
      type: Object,
    },
    // 分页数设置
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40],
    },
    loading: {
      default: false,
    },
    // 是否表格
    isTable: {
      type: Boolean,
      default: true,
    },
    tableData: {
      type: Array,
      default: [],
    },
    heightTable: {
      type: String,
      default: "",
    },
    smallPag: {
      type: Boolean,
      default: false,
    },
    layout: {
      type: String,
      default: "total,prev,pager,next,sizes,jumper",
    },
    destroy: {
      //是否销毁缩放事件
      type: Boolean,
      default: true,
    },
    bodyPadding: {
      //card内边距
      type: String,
      default: "10px 20px",
    },
    bodyBorder: {
      type: String,
      default: "1px solid #EBEEF5",
    },
    shadowType: {
      //card内边距
      type: String,
      default: "never",
    },
  },
  data() {
    return {
      height: 270,
      //    emptyText:"正在加载",
    };
  },
  computed: {
    // 返回表格选择项
    selection() {
      if (this.isTable) {
        return this.$refs.table.selection;
      }
      return this.$refs.cardTable.selection;
    },
    // 根据分辨率控制表格大小
    tableSize() {
      // const screenWidth = window.screen.width
      // console.log(screenWidth);
      // if (screenWidth > 1920) {
      //   return 'large'
      // }
      // if (screenWidth <= 1920 && screenWidth > 1680) {
      return "medium";
      // }
      // if (screenWidth <= 1680 && screenWidth >= 1367) {
      //   return 'small'
      // }
      // return 'mini'
    },
    emptyText() {
      if (this.loading) {
        return "正在加载";
      } else {
        return "暂无数据";
      }
    },
  },
  watch: {
    // 数据变化时表格滑动到最顶端
    tableData: {
      deep: true,
      handler(newVal) {
        if (newVal && this.resetScroll) {
          if (this.isTable) {
            this.$refs.table.bodyWrapper.scrollTop = 0;
          } else {
            this.$refs.cardTable.scrollTop = 0;
          }
          //数据变化对 Table 进行重新布局
          this.$nextTick(() => {
            this.$refs.table && this.$refs.table.doLayout();
          });
        }
      },
    },
    heightTable:{
      handler(value,oldValue){
        this.height = value || this.height
      },
      deep: true
    }
  },

  mounted() {
    this.clientHeight();
  },
  updated() {},
  destroyed() {
    if (this.destroy) {
      window.onresize = null;
    }
  },
  activated() {
    this.clientHeight();
  },
  methods: {
    /** 合并单元格 */
    onArraySpanMethod({ row, column, rowIndex, columnIndex }) {
      this.$emit('spanMethod',{ row, column, rowIndex, columnIndex })
    },
    clientHeight(gapHeight) {
      //重新渲染表格样式，防止表格样式错乱
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.doLayout();
      });
      if (!this.heightTable) {
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
          this.$refs.table && this.myUtils.pageTableHeight(this,gapHeight);
        });
      } else {
        this.$nextTick(() => {
          this.height = this.heightTable;
          this.$refs.table && this.$refs.table.doLayout();
        });
      }
    },
    // 全选
    toggleAllSelection() {
      if (this.isTable) {
        this.$refs.table.toggleAllSelection();
      } else {
        this.$refs.cardTable.toggleAllSelection();
      }
    },
    // 换页
    changePage(e) {
      this.$emit("changePage", e);
    },
    // 更换每页显示数量
    changeSize(e) {
      this.$emit("changeSize", e);
    },
    getRowkey(row) {
      return row.id;
    },
    cellClick(row, column, cell, event) {
      this.$emit("cell-click", row, column, cell, event);
    },
    rowDbclick(row, column, event) {
      this.$emit("row-dblclick", row, column, event);
    },
    rowClick(row, column, event) {
      this.$emit("row-click", row, column, event);
    },
    filterChange(e) {
      this.$emit("filter-change", e);
    },
    clearFilter(e) {
      this.$refs.table.columns[e].filteredValue = [];
    },
    selectionChange(e) {
      this.$emit("selection-change", e);
    },
  },
};
</script>
<style scoped>
.pagination-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ebeef5;
  border-top: none;
}

.pagination {
  border: none;
}

/*/deep/ .el-table .el-table__fixed {*/
/*  height: auto !important;*/
/*  bottom: 15px;*/
/*}*/

/*/deep/ .el-table .el-table__fixed-right {*/
/*  height: auto !important;*/
/*  bottom: 15px;*/
/*}*/
</style>
<style lang="css">
</style>





// WEBPACK FOOTER //
// src/components/childcomponents/AppTablePage/index.vue